<div class="lottie" *ngIf="data">
    <finder-component-header
        [data]="data.titleData"
    ></finder-component-header>
    @defer {
        <finder-lottie
            [data]="data"
        ></finder-lottie>
    }
</div>
